function formatDate(dateRaw) {
  const meses = [
    "Jan",
    "Fev",
    "Mar",
    "Abr",
    "Mai",
    "Jun",
    "Jul",
    "Ago",
    "Set",
    "Out",
    "Nov",
    "Dez",
  ];
  let data = new Date(dateRaw);
  let dataFormatada =
    data.getDate() +
    " " +
    meses[data.getMonth()] +
    " " +
    data.getFullYear() +
    " " +
    adicionaZero(data.getHours()) +
    ":" +
    adicionaZero(data.getMinutes());

  return dataFormatada;
}

function adicionaZero(numero) {
  if (numero <= 9) return "0" + numero;
  else return numero;
}

export default formatDate;
